import { useMemo, useState } from 'react'
import useScenario from './useScenario';
import useViewer from './useViewer';

const useTimeframe = () => {
    const { current_simulation_time } = useViewer();
    const { simulation_time, scenario, getUpdatedSimulationTime } = useScenario();

    const [showFrameButton, setShowFrameButton] = useState<"start" | "end" | null>(null)

    const simulation_start_time = useMemo(() => simulation_time?.start_time, [simulation_time]);
    const simulation_end_time = useMemo(() => simulation_time?.end_time, [simulation_time]);
    const simulation_duration = useMemo(() => (simulation_time?.duration ?? 0), [simulation_time]);
    const current_time = useMemo(() => current_simulation_time / 1000, [current_simulation_time]);

    const getUpdatedFrame = (boundary: string) => {
        if (!scenario) return
        const time = boundary === 'start' ? simulation_start_time : simulation_end_time
        getUpdatedSimulationTime(scenario, time, current_time, simulation_duration)
    }

    return {
        simulation_start_time,
        simulation_end_time,
        simulation_duration,
        current_time,
        showFrameButton,
        getUpdatedFrame,
        setShowFrameButton
    }
}

export default useTimeframe